export const baseCardStyles = {
    flex: 1,
    minWidth: 0,
    minHeight: '400px',
    height: 'auto',
    '@media (max-width: 768px)': {
        minHeight: '350px'
    }
};